import { render, staticRenderFns } from "./ElFlexWrapperV2.vue?vue&type=template&id=30f9e01f"
import script from "./ElFlexWrapperV2.vue?vue&type=script&lang=js"
export * from "./ElFlexWrapperV2.vue?vue&type=script&lang=js"
import style0 from "./ElFlexWrapperV2.vue?vue&type=style&index=0&id=30f9e01f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports